import saMessages from '../locales/he_IL.json';

const saLang = {
  messages: {
    ...saMessages,
  },
  locale: 'he-IL',
};
export default saLang;
